<a class="nu-skip" href="#main-content" (click)="skipToMain($event)">Skip to main content</a>

<div class="nu-backdrop" [class.show]="drawerOpen()" (click)="closeDrawer(true)" aria-hidden="true"></div>

<aside
  id="nu-sidebar"
  class="nu-sidebar"
  [class.icon-only]="iconOnly()"
  [class.open]="drawerOpen()"
  [attr.inert]="isMobile() && !drawerOpen() ? '' : null"
>
  <div class="nu-brand-row">
    <div class="nu-brand">
      <img
        class="nu-brand-logo"
        [src]="parentClubLogo()"
        alt="Club logo"
        referrerpolicy="no-referrer"
        (error)="onLogoError()"
      />
      @if (!iconOnly()) {
        <span class="nu-brand-name">{{ clubName() }}</span>
      }
    </div>
    <div class="nu-control-row">
      <button
        type="button"
        class="nu-icon-btn nu-collapse-btn"
        (click)="toggleCollapsed()"
        [attr.aria-label]="collapsed() ? 'Expand sidebar' : 'Collapse sidebar'"
        [attr.aria-expanded]="!collapsed()"
      >
        <i [class]="collapsed() ? 'pi pi-angle-double-right' : 'pi pi-angle-double-left'" aria-hidden="true"></i>
      </button>
      <button
        type="button"
        class="nu-icon-btn nu-close-btn"
        #drawerCloseBtn
        (click)="closeDrawer(true)"
        aria-label="Close navigation menu"
      >
        <i class="pi pi-times" aria-hidden="true"></i>
      </button>
    </div>
  </div>

  <nav class="nu-nav" aria-label="Primary">
    @if (isSuperUserLoggedIn()) {
      <ul class="nu-list" role="list">
        <li>
          <a
            class="nu-link"
            routerLink="/main/dashboard/superUserDashboardComponent"
            routerLinkActive="active"
            ariaCurrentWhenActive="page"
            pTooltip="Super User Dashboard"
            tooltipPosition="right"
            [tooltipDisabled]="!iconOnly()"
            aria-label="Super User Dashboard"
          >
            <i class="pi pi-shield nu-icon" aria-hidden="true"></i>
            @if (!iconOnly()) {
              <span class="nu-text">Super User Dashboard</span>
            }
          </a>
        </li>
      </ul>
    }

    @for (group of groups(); track group.label; let first = $first) {
      <div class="nu-group" [class.divider]="!first">
        @if (group.label) {
          <p class="nu-group-label" [attr.aria-hidden]="iconOnly() ? 'true' : null">{{ group.label }}</p>
        }
        <ul class="nu-list" role="list" [attr.aria-label]="group.label || null">
          @for (menu of group.items; track menuKey(menu)) {
            <li>
              @if (menu.subMenu.length === 0) {
                <a
                  class="nu-link"
                  [routerLink]="'/' + menu.route"
                  routerLinkActive="active"
                  [routerLinkActiveOptions]="{ exact: menu.route === dashboardRoute }"
                  ariaCurrentWhenActive="page"
                  [pTooltip]="menu.name"
                  tooltipPosition="right"
                  [tooltipDisabled]="!iconOnly()"
                  [attr.aria-label]="menu.name"
                >
                  @if (iconFor(menu.name); as icon) {
                    <i [class]="'pi nu-icon ' + icon" aria-hidden="true"></i>
                  } @else {
                    <img class="nu-icon nu-icon-img" [src]="menu.icon" alt="" />
                  }
                  @if (!iconOnly()) {
                    <span class="nu-text">{{ menu.name }}</span>
                  }
                </a>
              } @else {
                <button
                  type="button"
                  class="nu-link nu-parent"
                  [class.has-active]="isActiveParent(menu)"
                  (click)="toggleParent(menu)"
                  [pTooltip]="menu.name"
                  tooltipPosition="right"
                  [tooltipDisabled]="!iconOnly()"
                  [attr.aria-label]="menu.name"
                  [attr.aria-expanded]="isOpenParent(menu)"
                  [attr.aria-controls]="subId(menu)"
                >
                  @if (iconFor(menu.name); as icon) {
                    <i [class]="'pi nu-icon ' + icon" aria-hidden="true"></i>
                  } @else {
                    <img class="nu-icon nu-icon-img" [src]="menu.icon" alt="" />
                  }
                  @if (!iconOnly()) {
                    <span class="nu-text">{{ menu.name }}</span>
                    <i class="pi pi-chevron-down nu-chevron" [class.rotated]="isOpenParent(menu)" aria-hidden="true"></i>
                  }
                </button>
                <div class="nu-sub" [class.open]="isOpenParent(menu)" [attr.inert]="isOpenParent(menu) ? null : ''">
                  <ul class="nu-sub-list" role="list" [id]="subId(menu)">
                    @for (sub of menu.subMenu; track sub.route) {
                      <li>
                        <a
                          class="nu-link nu-sub-link"
                          [routerLink]="'/' + sub.route"
                          routerLinkActive="active"
                          ariaCurrentWhenActive="page"
                        >
                          @if (iconFor(sub.name); as subIcon) {
                            <i [class]="'pi nu-icon ' + subIcon" aria-hidden="true"></i>
                          } @else {
                            <img class="nu-icon nu-icon-img" [src]="sub.icon" alt="" />
                          }
                          <span class="nu-text">{{ sub.name }}</span>
                        </a>
                      </li>
                    }
                  </ul>
                </div>
              }
            </li>
          }
        </ul>
      </div>
    }
  </nav>

  <div class="nu-account-wrap" #accountWrap>
    @if (accountOpen()) {
      <div class="nu-account-menu" role="menu" aria-label="Account">
        <button type="button" class="nu-menu-item" role="menuitem" (click)="logout()">
          <i class="pi pi-sign-out" aria-hidden="true"></i>
          <span>Log out</span>
        </button>
      </div>
    }
    <button
      type="button"
      class="nu-account"
      #accountBtn
      (click)="toggleAccount()"
      aria-haspopup="menu"
      [attr.aria-expanded]="accountOpen()"
      [attr.aria-label]="'Account menu' + (userName() ? ' for ' + userName() : '')"
      [pTooltip]="userName()"
      tooltipPosition="right"
      [tooltipDisabled]="!iconOnly() || !userName()"
    >
      <span class="nu-avatar" aria-hidden="true">{{ initial() }}</span>
      @if (!iconOnly()) {
        <span class="nu-account-info">
          <span class="nu-account-name">{{ userName() }}</span>
          <span class="nu-account-email">{{ maskedEmail() }}</span>
        </span>
        <i class="pi pi-chevron-up nu-account-chevron" [class.rotated]="accountOpen()" aria-hidden="true"></i>
      }
    </button>
  </div>
</aside>

<header class="nu-header" [attr.inert]="drawerModal() ? '' : null">
  <div class="nu-header-left">
    @if (isAdminAppWebView()) {
      <button
        type="button"
        class="nu-icon-btn nu-header-btn"
        (click)="navigateHomeFromApp()"
        aria-label="Return to app home"
        title="Home"
      >
        <i class="pi pi-home" aria-hidden="true"></i>
      </button>
    }
    <button
      type="button"
      class="nu-icon-btn nu-header-btn nu-hamburger"
      #hamburgerBtn
      (click)="openDrawer()"
      aria-label="Open navigation menu"
      aria-controls="nu-sidebar"
      [attr.aria-expanded]="drawerOpen()"
    >
      <i class="pi pi-bars" aria-hidden="true"></i>
    </button>
  </div>

  <div class="nu-header-right">
    <div class="nu-toggles">
      <app-ui-toggle></app-ui-toggle>
      <app-theme-toggle></app-theme-toggle>
    </div>

    @if (showAccentPicker) {
      <div class="nu-accent" #accentWrap>
        <button
          type="button"
          class="nu-icon-btn nu-header-btn"
          #accentBtn
          (click)="toggleAccentPicker()"
          aria-label="Appearance settings"
          aria-haspopup="dialog"
          aria-controls="nu-accent-pop"
          [attr.aria-expanded]="accentOpen()"
          title="Appearance settings"
        >
          <i class="pi pi-palette" aria-hidden="true"></i>
        </button>
        @if (accentOpen()) {
          <div class="nu-pop" id="nu-accent-pop" role="dialog" aria-labelledby="nu-accent-title">
            <div class="nu-pop-head">
              <span class="nu-pop-title" id="nu-accent-title">Appearance</span>
              <button
                type="button"
                class="nu-icon-btn"
                (click)="closeAccentPicker(true)"
                aria-label="Close appearance settings"
              >
                <i class="pi pi-times" aria-hidden="true"></i>
              </button>
            </div>
            <p class="nu-cap" id="nu-accent-label">Accent colour</p>
            <div class="nu-swatches" role="group" aria-labelledby="nu-accent-label">
              @for (preset of accentPresets; track preset.id) {
                <button
                  type="button"
                  class="nu-sw-btn"
                  [class.is-on]="accentId() === preset.id"
                  [attr.aria-label]="preset.label + ' accent'"
                  [attr.aria-pressed]="accentId() === preset.id"
                  (click)="selectAccent(preset.id)"
                >
                  <span class="nu-sw-dot" [style.background]="preset.accent"></span>
                </button>
              }
            </div>
          </div>
        }
      </div>
    }

    <button
      type="button"
      class="nu-ask-ai"
      #askAiBtn
      (click)="isAiAssistantOpen() ? closeAiAssistant() : openAiAssistant()"
      aria-label="Ask AI"
      aria-haspopup="dialog"
      [attr.aria-expanded]="isAiAssistantOpen()"
      title="Ask AI"
    >
      <i class="pi pi-sparkles" aria-hidden="true"></i>
      <span class="nu-ask-ai-label">Ask AI</span>
    </button>
  </div>
</header>

<main class="nu-main" id="main-content" #mainEl tabindex="-1" [attr.inert]="drawerModal() ? '' : null">
  <ng-content></ng-content>
</main>

<app-ai-assistant [isOpen]="isAiAssistantOpen()" (closeAssistant)="closeAiAssistant()"></app-ai-assistant>

<app-confirm-dialog
  [visible]="showLogoutConfirm()"
  title="Log out"
  message="Are you sure you want to log out?"
  icon="pi pi-sign-out"
  iconColor="var(--nu-teal)"
  confirmLabel="Log out"
  confirmIcon="pi pi-sign-out"
  confirmColor="primary"
  (confirmed)="performLogout()"
  (cancelled)="showLogoutConfirm.set(false)"
/>
